import type { PropAsset } from "./PropAsset";
import type { PropLibrary } from "./propLibraryBinaryConstants";
import { loadPropLibrary } from "./propLibraryRuntime";

export async function getBuiltinPropLibrary(enableAwsLibrary: boolean = false): Promise<PropLibrary> {
  return await loadPropLibrary(enableAwsLibrary);
}

export async function getBuiltinProp(
  id: string | number,
  enableAwsLibrary: boolean = false,
): Promise<PropAsset | undefined> {
  const builtinPropLibrary = await loadPropLibrary(enableAwsLibrary);
  if (typeof id === "string") {
    id = parseInt(id);
  }
  return builtinPropLibrary.has(id) ? builtinPropLibrary.get(id) : undefined;
}
